import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "../../component/ui/Button";

// 1. Updated Swiper Imports to include Navigation
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

// 2. Added Navigation CSS
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

gsap.registerPlugin(ScrollTrigger);

const MediaSection = () => {
  const sectionRef = useRef(null);
  const [playingId, setPlayingId] = useState(null);

  useEffect(() => {
    const context = gsap.context(() => {
      const textElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".news-header-text"),
      );

      textElements.forEach((element, index) => {
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.current.querySelector(".news-header-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
        tl.to(element, {
          y: 0,
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)",
          duration: 1,
          ease: "power2.out",
          delay: index * 0.1,
        });
      });

      const lineElement =
        sectionRef.current.querySelector(".news-divider-line");
      if (lineElement) {
        gsap.set(lineElement, { scaleX: 0, transformOrigin: "left" });
        gsap.to(lineElement, {
          scaleX: 1,
          duration: 1,
          ease: "none",
          scrollTrigger: {
            trigger: lineElement.closest(".news-subtitle-container"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
      }
    }, sectionRef);
    return () => context.revert();
  }, []);

  const newsArticles = [
    {
      id: 1,
      title: "Modi Sir",
      description: "Environment Days",
      image: "/images/Press/pmImage.webp",
      videoUrl: "https://www.youtube.com/embed/yzsfTxXWKA8?si=yUaE6mpA6lTZc5w9",
    },
    {
      id: 2,
      title: "Public Meeting",
      description: "Kheda, Gujarat",
      image: "/images/media/media2.webp",
      videoUrl: "https://www.youtube.com/embed/-tj7fDnhgWc?si=ASs9tBnUBcPjL_M-",
    },
    {
      id: 3,
      title: "PM - Narendra Modi",
      description: "Addresses Bio-gas Plant",
      image: "/images/media/media3.webp",
      videoUrl: "https://www.youtube.com/embed/W5QO4dgncDM?si=ZFjY2fnGhuMsmOxd",
    },
    {
      id: 4,
      title: "Republic TV",
      description: "Renewable Energy ",
      image: "/images/media/media4.webp",
      videoUrl: "https://www.youtube.com/embed/7DLb8WRDoxA?si=bsNYBwHt8WRYNGQ8",
    },
    // {
    //   id: 5,
    //   title: "DD Girnar",
    //   description: "Shri Parshottam Rupala's Visit ",
    //   image: "/images/media/media2.webp",
    //   videoUrl: "https://www.youtube.com/embed/dAj4koXnbtA?si=TUAiYkyz25sJyZbd",
    // },
    {
      id: 5,
      title: "India's First CBG-CDG",
      description: "Syncronization GELLP-GAIL",
      image: "/images/media/media5.webp",
      videoUrl: "https://www.youtube.com/embed/331F0Dk4luM?si=BhaF2FiAQ5IkCLUG",
    },
    {
      id: 6,
      title: "Corporate Video",
      description: "Leading India’s Biogas Revolution",
      image: "/images/media/media6.webp",
      videoUrl: "https://www.youtube.com/embed/sI9zIPxDllw?si=euRSWcfhV7zMy",
    },
  ];

  const swiperParams = {
    modules: [Pagination, Navigation],
    loop: true,
    speed: 500,
    pagination: {
      el: ".media-pagination", // Custom dots container
      clickable: true,
    },
    navigation: {
      nextEl: ".media-next", // Custom next arrow
      prevEl: ".media-prev", // Custom prev arrow
    },
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 20,
    breakpoints: {
      320: { slidesPerView: 1, centeredSlides: true, spaceBetween: 15 },
      640: { slidesPerView: 2, centeredSlides: false, spaceBetween: 20 },
      1160: { slidesPerView: 3, centeredSlides: false, spaceBetween: 20 },
    },
  };

  return (
    <>
      <style global jsx>{`
        /* Desktop: Navigation hide */
        .media-mobile-nav {
          display: none;
        }

        /* Mobile Only Styles */
        @media (max-width: 640px) {
          .media-mobile-nav {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 25px;
            margin-top: 20px;
          }

          /* Dots Styling */
          .media-pagination {
            display: flex !important;
            width: auto !important;
            gap: 10px;
          }
          .media-pagination .swiper-pagination-bullet {
            background: #1c233a;
            opacity: 0.3;
            margin: 0 !important;
            width: 8px;
            height: 8px;
          }
          .media-pagination .swiper-pagination-bullet-active {
            opacity: 1;
            width: 24px;
            border-radius: 4px;
            transition: all 0.3s ease;
          }

          /* Arrow Buttons Styling */
          .media-prev,
          .media-next {
            color: #1c233a;
            font-size: 22px;
            cursor: pointer;
            user-select: none;
            line-height: 1;
          }
        }
      `}</style>

      <section
        ref={sectionRef}
        className="w-auto py-[27px] sm:py-[40px] 2xl:py-[54px]"
      >
        {/* Section Header */}
        <div className="flex flex-col gap-[11px] sm:gap-[16px] 2xl:gap-[22px] px-[32px] md:px-[112px] 2xl:px-[150px] news-header-container">
          <div className="flex flex-row justify-start items-center w-full news-subtitle-container overflow-hidden">
            <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-[Sora] news-header-text text-[#1c233a]">
              News
            </p>
            <div className="w-[100px] sm:w-[150px] 2xl:w-[200px] h-[1px] bg-[#1c233a] mb-[7px] ml-[15px] news-divider-line"></div>
          </div>
          <h2 className="text-[30px] sm:text-[45px] 2xl:text-[60px] font-bold text-[#1c233a] font-[Sora] news-header-text">
            Media
          </h2>
          <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal text-[#1c233a] font-[Sora] news-header-text">
            Video highlights and event coverage showcasing CBG plant operations
            and milestones.
          </p>
        </div>

        <div className="block md:hidden mt-[30px] sm:mt-[45px] 2xl:mt-[60px] max-w-[1620px] m-auto px-[30px]">
          <Swiper {...swiperParams}>
            {newsArticles?.map((article) => (
              <SwiperSlide key={article?.id} className="p-2">
                <div className="flex flex-col w-full group">
                  <div className="relative w-full aspect-video overflow-hidden rounded-[20px] lg:rounded-[30px]">
                    {playingId === article.id && article.videoUrl ? (
                      <div className="relative w-full h-full">
                        <iframe
                          src={`${article.videoUrl}&autoplay=1`}
                          className="w-full h-full"
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        ></iframe>
                        <button
                          onClick={() => setPlayingId(null)}
                          className="absolute top-2 right-2 bg-white/20 p-2 w-[30px] h-[30px] flex items-center justify-center rounded-full text-white backdrop-blur-md"
                        >
                          ✕
                        </button>
                      </div>
                    ) : (
                      <div
                        className="relative w-full h-full cursor-pointer"
                        onClick={() =>
                          article.videoUrl && setPlayingId(article.id)
                        }
                      >
                        <img
                          src={article?.image}
                          alt={article?.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        {article.videoUrl && (
                          <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/30 transition-all">
                            <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
                              <div className="ml-1 w-0 h-0 border-t-[10px] border-t-transparent border-l-[18px] border-l-[#1C233A] border-b-[10px] border-b-transparent"></div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-1 mt-4 px-1">
                    <h3 className="text-[20px] sm:text-[24px] 2xl:text-[28px] font-bold text-[#1C233A] font-[Sora]">
                      {article?.title}
                    </h3>
                    <p className="text-[14px] sm:text-[16px] 2xl:text-[18px] font-normal text-gray-500 font-[Sora]">
                      {article?.description}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* CUSTOM BOTTOM NAVIGATION FOR MOBILE */}
          <div className="media-mobile-nav">
            <div className="media-prev">❮</div>
            <div className="media-pagination"></div>
            <div className="media-next">❯</div>
          </div>
        </div>
        <div className="hidden md:flex flex-wrap mt-[30px] justify-center xl:justify-start gap-[50px] sm:mt-[45px] 2xl:mt-[60px] px-[32px] md:px-[112px] 2xl:px-[130px] m-auto px-[30px]">
          {/* <Swiper {...swiperParams}> */}
          {newsArticles?.map((article) => (
            // <SwiperSlide key={article?.id} className="p-2">
            <div className="flex flex-col w-full group w-[45%] xl:w-[30.333%]">
              <div className="relative w-full aspect-video overflow-hidden rounded-[20px] lg:rounded-[30px]">
                {playingId === article.id && article.videoUrl ? (
                  <div className="relative w-full h-full">
                    <iframe
                      src={`${article.videoUrl}&autoplay=1`}
                      className="w-full h-full"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    ></iframe>
                    <button
                      onClick={() => setPlayingId(null)}
                      className="absolute top-2 right-2 bg-white/20 p-2 w-[30px] h-[30px] flex items-center justify-center rounded-full text-white backdrop-blur-md"
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div
                    className="relative w-full h-full cursor-pointer"
                    onClick={() => article.videoUrl && setPlayingId(article.id)}
                  >
                    <img
                      src={article?.image}
                      alt={article?.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    {article.videoUrl && (
                      <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/30 transition-all">
                        <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-xl transition-transform group-hover:scale-110">
                          <div className="ml-1 w-0 h-0 border-t-[10px] border-t-transparent border-l-[18px] border-l-[#1C233A] border-b-[10px] border-b-transparent"></div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-1 mt-4 px-1">
                <h3 className="text-[20px] sm:text-[24px] 2xl:text-[28px] font-bold text-[#1C233A] font-[Sora]">
                  {article?.title}
                </h3>
                <p className="text-[14px] sm:text-[16px] 2xl:text-[18px] font-normal text-gray-500 font-[Sora]">
                  {article?.description}
                </p>
              </div>
            </div>
            // </SwiperSlide>
          ))}
          {/* </Swiper> */}
        </div>
      </section>
    </>
  );
};

export default MediaSection;
